module.exports = "/static-assets/_next/static/images/underwearRat-7817c5113304bb4423ace28a561d136f.png";